import type { Course } from '@eliadmin/core/src/api/courses/coursers-api';
import { buildAuthHeader, fetchData } from '@eliadmin/core/src/api/fetcher';

export type CourseContact = { phone: string | null; email: string | null };

export function fetchCustomerCourses({
  locale,
  authToken,
  page = 1,
  courseId,
}: {
  locale: string;
  authToken: string;
  page?: number;
  courseId?: number;
}) {
  return fetchData<{ data: Course[]; meta: { current_page: number; last_page: number } }>({
    method: 'GET',
    uri: '/course/customer/courses',
    locale,
    headers: buildAuthHeader(authToken),
    cache: 'no-store',
    query: { page, results: 20, ...(courseId ? { course_id: courseId } : {}) },
  });
}

export function fetchCourseContact(courseId: number, locale: string) {
  return fetchData<{ data: CourseContact }>({
    method: 'GET',
    uri: `/course/courses/${courseId}/contact`,
    locale,
    cache: 'no-store',
  });
}

export function recordCourseInteraction(
  courseId: number,
  locale: string,
  action: 'view_course' | 'click_show_phone' | 'click_show_email',
  eventId: string,
) {
  return fetchData({
    method: 'POST',
    uri: '/store/interactions',
    locale,
    body: {
      event_id: eventId,
      target_type: 'course',
      target_id: String(courseId),
      action,
      metadata: { placement: 'course_detail' },
    },
  });
}
